import React from "react";

/**
 * Figures card for member money answers. Title, rows and the fine-print
 * note all come from the backend's own calculation code — never the model.
 */
export function FiguresCard({ card, idx }) {
  if (!card || !Array.isArray(card.rows)) return null;
  return (
    <div
      className="mb-2 rounded-md border border-[#E6E3DB] bg-white px-3 py-2.5"
      data-testid={`chat-figures-card-${idx}`}
    >
      <p className="text-[10px] uppercase tracking-wider text-[#787671] mb-1.5" data-testid={`chat-figures-title-${idx}`}>
        {card.title}
      </p>
      <dl className="space-y-1">
        {card.rows.map((r, i) => (
          <div key={i} className="flex items-baseline justify-between gap-3" data-testid={`chat-figures-row-${idx}-${i}`}>
            <dt className="text-xs text-[#787671]">{r.label}</dt>
            <dd className="text-sm font-medium text-[#2C302E] tabular-nums text-right">{r.value}</dd>
          </div>
        ))}
      </dl>
      {card.note && (
        <p
          className="mt-2 pt-1.5 border-t border-[#EAE7DF] text-[11px] leading-snug text-[#787671]"
          data-testid={`chat-figures-disclaimer-${idx}`}
        >
          {card.note}
        </p>
      )}
    </div>
  );
}

export default FiguresCard;
